import {useI18n} from 'store/Store'
import {useNavigate} from 'services/hooks'
import {getSearchBoxStyles} from 'appearance/styles'

const UseSearchArea = ({isFlex, open}) => {
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const {searchBoxSx, searchBarSx} = getSearchBoxStyles(isFlex[!open])

    const goToDance = (value) => {
        navigate(`/dance/${value?._id}`)
        // navigate(`/`)
    }

    const inputText = i18n.t('search.input')
    const noOptionsText = i18n.t('general.loading')
    return {goToDance, searchBarSx, searchBoxSx, inputText, noOptionsText}
}

export default UseSearchArea
